module.exports = __webpack_public_path__ + "img/材料力学1_7_6.b7d1a03e.jpg";